import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['toggle'];

  connect() {
    this.hidePastEvents();
    this.overlay = document.querySelector('.js-embed-overlay');
    this.closeBtn = document.querySelector('.js-close-embed-overlay');
    this.iframe = document.querySelector('.js-embed-iframe');
    this.closeBtn.addEventListener('click', this.close.bind(this));
  }

  hidePastEvents() {
    let now = new Date();
    let eventDateTime = new Date(Date.parse(this.element.dataset.datetime));
    if (eventDateTime < now) this.element.remove();
    this.dispatchCompletedEvent();
  }

  open(e) {
    e.preventDefault();
    let url = e.currentTarget.dataset.embedUrl;
    if (url == '') return;
    this.overlay.classList.add('is-open');
    this.iframe.setAttribute('src', url);
  }

  close(e) {
    e.preventDefault();
    this.overlay.classList.remove('is-open');
    this.iframe.setAttribute('src', '');
  }

  dispatchCompletedEvent() {
    const event = new CustomEvent('detailedScreeningCardProcessed', { bubbles: true });
    this.element.dispatchEvent(event);
  }
}
